import API from '@/lib/API';

export const projectService = {
  getProjects: async (params) => {
    const response = await API.get('/verve-projects', { params });
    return response.data;
  },


  /** Tower accounts: per-project financials + general expense by user */
  getAccountsOverview: async (params) => {
    const response = await API.get('/verve-projects/accounts-overview', { params });
    return response;
  },

  getProjectManagers: async () => {
    const response = await API.get('/verve-projects/managers');
    return response?.data?.data || response?.data || response;
  },

  getFieldOfficers: async () => {
    const response = await API.get('/verve-projects/field-officers');
    return response?.data?.data || response?.data || response;
  },

  getProjectById: async (id) => {
    try {
      const response = await API.get(`/verve-projects/${id}`);
      if (response && response.data && response.data.data) {
        response.data = response.data.data;
      }
      return response?.data || response;
    } catch (err) {
      throw err;
    }
  },

  createProject: async (data) => {
    const response = await API.post('/verve-projects', data);
    return response;
  },

  updateProject: async (id, data) => {
    const response = await API.put(`/verve-projects/${id}`, data);
    return response;
  },

  /** Dedicated PM assignment — avoids multer, checks already-assigned, syncs to vervecontacts. */
  assignProjectManager: async (id, data) => {
    const response = await API.put(`/verve-projects/${id}/assign-manager`, data);
    return response;
  },

  addProjectActivityNote: async (id, text) => {
    const response = await API.post(`/verve-projects/${id}/activity-note`, { text });
    return response;
  },

  /** Field officer: confirm on-site material received for this project. */
  confirmMaterialReceipt: async (id) => {
    const response = await API.post(`/verve-projects/${id}/material-receipt`);
    return response;
  },

  /** Materials marked received on site for this project (aggregated from dispatched requests). */
  getSiteInventory: async (id) => {
    const response = await API.get(`/verve-projects/${id}/site-inventory`);
    return response;
  },

  postTradeWorkUpdate: async (id, formData) => {
    const response = await API.post(`/verve-projects/${id}/trade-work-update`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response;
  },

  deleteDocument: async (projectId, documentId) => {
    const response = await API.delete(`/verve-projects/${projectId}/documents/${documentId}`);
    return response.data;
  },

  deleteProject: async (id) => {
    const response = await API.delete(`/verve-projects/${id}`);
    return response;
  },

  /** Credit or expense ledger entry for tower project payment summary. */
  getProjectTransactions: async (projectId) => {
    const response = await API.get(`/verve-projects/${projectId}/transactions`);
    return response;
  },

  /** Credit or expense ledger entry for tower project payment summary. */
  createProjectTransaction: async (projectId, body) => {
    const response = await API.post(`/verve-projects/${projectId}/transactions`, body);
    return response;
  },

  /** Owner/admin: all credit transactions (money in) for Expense oversight tab. */
  listTowerCredits: async (params = {}) => {
    const response = await API.get('/verve-projects/tower-credits', { params });
    return response;
  },

  /** Multipart: signed docs at Balance update stage (fields: files[], notes). */
  uploadBalanceDocuments: async (projectId, formData) => {
    const response = await API.post(`/verve-projects/${projectId}/balance-documents`, formData);
    return response;
  },

  /** Owner requests: completion tab — signed docs done, not yet Completed, with payment summary. */
  getCompletionQueue: async (params = {}) => {
    const response = await API.get('/verve-projects/completion-queue', { params });
    return response;
  },

  postCompletionReminder: async (projectId) => {
    const response = await API.post(`/verve-projects/${projectId}/completion-reminder`);
    return response;
  },

  postApproveCompletion: async (projectId) => {
    const response = await API.post(`/verve-projects/${projectId}/approve-completion`);
    return response;
  },

  getTowerNotifications: async () => {
    const response = await API.get('/verve-projects/tower-notifications');
    return response;
  },

  markTowerNotificationRead: async (notifId) => {
    const response = await API.patch(`/verve-projects/tower-notifications/${notifId}/read`);
    return response;
  },

  markAllTowerNotificationsRead: async () => {
    const response = await API.patch('/verve-projects/tower-notifications/mark-all-read');
    return response;
  },

  getProjectAnalytics: async (params) => {
    const response = await API.get('/verve-projects/analytics', { params });
    return response;
  },

  downloadInvoice: async (projectId) => {
    const response = await API.get(`/verve-projects/${projectId}/invoice`, {
      responseType: 'blob'
    });
    return response;
  },

  downloadDocument: async (filePath) => {
    // We use the same reliable logic as invoices: stream directly from the backend
    const response = await API.get(`/verve-projects/documents/stream?filePath=${encodeURIComponent(filePath)}`, {
      responseType: 'blob'
    });
    return response;
  }
};
